import React, { useEffect } from 'react';
import proptypes from 'prop-types';
import { useStoreId } from '@thd-nucleus/experience-context';
import { useDataModel } from '@thd-nucleus/data-sources';
import { ready } from './publisher';
import { dataModel } from '../dataModel';
import { CollectionTabs } from './collection-tabs/CollectionTabs';

const { string } = proptypes;

export const CollectionInfoTabsDesktop = ({ collectionId }) => {
  useEffect(() => {
    ready();
  }, []);

  const storeId = useStoreId();

  const { data } = useDataModel('collection', { variables: { collectionId, storeId } });
  const { collection } = data || {};
  const { descriptors, details, metadata } = collection || {};
  const { description, descriptiveAttributes } = details || {};

  return (
    <div data-component="CollectionInfoTabsDesktop">
      <CollectionTabs
        descriptors={descriptors}
        descriptiveAttributes={descriptiveAttributes}
        description={description}
        metadata={metadata}
      />
    </div>
  );
};

CollectionInfoTabsDesktop.displayName = 'CollectionInfoTabsDesktop';

CollectionInfoTabsDesktop.dataModel = dataModel;

CollectionInfoTabsDesktop.propTypes = {
  collectionId: string.isRequired
};
